import { render, staticRenderFns } from "./SettingsBranch.vue?vue&type=template&id=6f0d4e1c&scoped=true&"
import script from "./SettingsBranch.vue?vue&type=script&lang=js&"
export * from "./SettingsBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d4e1c",
  null
  
)

export default component.exports